export function robotHeader() {
    return <meta name="robots" content="noindex, nofollow" />;
}